import React, { Component } from 'react';
import { EuiProvider, EuiSuperDatePicker } from '@elastic/eui';
import dateMath from '@elastic/datemath';
import '@elastic/eui/dist/eui_theme_light.css';
export default class DatePicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startMoment: localStorage.getItem('startMoment') || 'now/d',
      endMoment: localStorage.getItem('endMoment') || 'now/d',
    };
    this.search = $('#search-box')[0];
    if (this.search) {
      this.search.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.onTimeRefresh();
        }
      });
    }
    this.onTimeChange = ({ start, end }) => {
      localStorage.setItem('startMoment', start);
      localStorage.setItem('endMoment', end);
      this.handleStateChange(start, 'startMoment');
      this.handleStateChange(end, 'endMoment');
    };

    window.getRPMLogsHxVals = () => {
      const start = dateMath.parse(this.state.startMoment);
      const end = dateMath.parse(this.state.endMoment, { roundUp: true });
      const filterNoise = document.getElementById('filter-noise');
      return {
        start: start && start.isValid() ? start.toISOString() : '',
        end: end && end.isValid() ? end.toISOString() : '',
        filter_noise: filterNoise && filterNoise.checked ? '1' : '0',
      };
    };

    this.onTimeRefresh = () => {
      const startMoment = dateMath.parse(this.state.startMoment);
      const endMoment = dateMath.parse(this.state.endMoment, { roundUp: true });
      const url = new URL(location);

      const search = this.search ? this.search.value : '';
      if (search) {
        url.searchParams.set('search', search);
      } else {
        url.searchParams.delete('search');
      }

      const filterNoise = document.getElementById('filter-noise');
      url.searchParams.set(
        'filter_noise',
        filterNoise && filterNoise.checked ? '1' : '0',
      );

      url.searchParams.set('start', startMoment.toISOString());
      url.searchParams.set('end', endMoment.toISOString());
      window.location.search = url.searchParams;
    };
  }

  handleStateChange(e, attribute) {
    this.setState({ [attribute]: e });
  }

  render() {
    const { startMoment, endMoment } = this.state;

    return (
      <div className={'date-piker'}>
        <EuiProvider colorMode='light'>
          <EuiSuperDatePicker
            end={endMoment}
            showUpdateButton={true}
            start={startMoment}
            onRefresh={this.onTimeRefresh}
            onTimeChange={this.onTimeChange}
          />
        </EuiProvider>
      </div>
    );
  }
}
